import TvIcon from "@mui/icons-material/Tv";

import type { PartyTvCastSupport } from "../types/api";

const ICON_PX = 18;

/** `yes` / `both` = TV‑friendly; `no` = struck TV (pass‑and‑play / not TV‑first). */
export function PartyTvCastGlyph({ support }: { support: PartyTvCastSupport }) {
  const color = "var(--ink-dim)";
  if (support === "yes" || support === "both") {
    return (
      <span style={{ display: "inline-flex", lineHeight: 0 }} aria-hidden>
        <TvIcon style={{ fontSize: ICON_PX, color }} />
      </span>
    );
  }
  return (
    <span style={{ position: "relative", display: "inline-flex", lineHeight: 0 }} aria-hidden>
      <TvIcon style={{ fontSize: ICON_PX, color, opacity: 0.42 }} />
      <span
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          top: "50%",
          height: 2,
          marginTop: -1,
          background: color,
          transform: "rotate(-36deg)",
          borderRadius: 1,
          pointerEvents: "none",
        }}
      />
    </span>
  );
}
